import React, { useEffect, useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Button,
} from '@mui/material';

interface LinkPromptDialogProps {
    open: boolean;
    title?: string;
    label?: string;
    initialUrl?: string;
    allowRemove?: boolean;
    onClose: () => void;
    onSubmit: (url: string | null) => void;
}

/**
 * MUI-Dialog als Ersatz für `window.prompt('URL', ...)` in TipTap-basierten
 * Editoren. Browser-Prompts blocken den Thread und ignorieren das Theme.
 */
export const LinkPromptDialog: React.FC<LinkPromptDialogProps> = ({
    open,
    title = 'Link setzen',
    label = 'URL',
    initialUrl = '',
    allowRemove = true,
    onClose,
    onSubmit,
}) => {
    const [url, setUrl] = useState(initialUrl);

    useEffect(() => {
        if (open) setUrl(initialUrl);
    }, [open, initialUrl]);

    const handleSubmit = () => {
        onSubmit(url);
        onClose();
    };

    const handleCancel = () => {
        onSubmit(null);
        onClose();
    };

    const handleRemove = () => {
        onSubmit('');
        onClose();
    };

    return (
        <Dialog open={open} onClose={handleCancel} fullWidth maxWidth="sm">
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>
                <TextField
                    autoFocus
                    margin="dense"
                    label={label}
                    type="url"
                    fullWidth
                    value={url}
                    onChange={(e) => setUrl(e.target.value)}
                    placeholder="https://…"
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') handleSubmit();
                    }}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCancel}>Abbrechen</Button>
                {allowRemove && initialUrl && (
                    <Button onClick={handleRemove} color="error">
                        Entfernen
                    </Button>
                )}
                <Button onClick={handleSubmit} variant="contained">
                    Übernehmen
                </Button>
            </DialogActions>
        </Dialog>
    );
};
